import {
  DefaultFetchError, FetchCreate, FetchSuccess, useFetchCreate,
} from '../fetch';

export const useSendVerificationCode = (id: string): FetchCreate => (
  useFetchCreate(`businesses/${id}/send-verification-code`, { autoStart: false, startStateLoading: false })
);

export interface VerifyCodeBody { code: string; }
export interface VerifyCodeData { secretKey: string; }

export interface IPhoneNumberBody { phone: string; }
export interface IVerifyCodeBody { phone: string; code: string; }

export const useVerifyCode = (id: string): FetchCreate<VerifyCodeData, DefaultFetchError, VerifyCodeBody> => (
  useFetchCreate(`businesses/${id}/verify-code`, { autoStart: false, startStateLoading: false })
);

export interface ClaimBusinessBody { secretKey: string; }
export interface ClaimBusinessesBody extends ClaimBusinessBody {
  ids: string[];
}

export const useClaimBusiness = (
  id: string | undefined,
): FetchCreate<FetchSuccess, DefaultFetchError, ClaimBusinessBody> => (
  useFetchCreate(`businesses${id ? `/${id}/become-owner` : ''}`, { autoStart: false, startStateLoading: false })
);

export const useClaimBusinesses = (): FetchCreate<FetchSuccess, DefaultFetchError, ClaimBusinessesBody> => (
  useFetchCreate('businesses/become-owner', { autoStart: false, startStateLoading: false })
);

export const useRevokeBusinessOwnership = (id: string): FetchCreate => (
  useFetchCreate(`businesses/${id}/revoke-ownership
`, { autoStart: false, startStateLoading: false })
);

export const usePhoneNumber = (): FetchCreate<FetchSuccess, DefaultFetchError, IPhoneNumberBody> => (
  useFetchCreate('businesses/send-verification-code-to-number', {
    autoStart: false,
    startStateLoading: false,
  })
);

export const useSendVerifyCode = (): FetchCreate<
  { list: any, secretKey: string }, DefaultFetchError, IVerifyCodeBody> => (
  useFetchCreate('businesses/verify-code-by-phone', { autoStart: false, startStateLoading: false })
);
